import React from 'react'

import {ConnectedProps} from 'react-redux'

import * as toastActions from '../actions/toast'
import {State} from '../reducers'

import {connect} from '../../../commons/src/services/loop'

import ToastLayout from '../../../commons/src/components/toast-layout'
import Toast from '../../../commons/src/components/toast-layout/toast'
import PageLayout from '../components/page-layout'

import FooterPartial from './footer-partial'
import NavigationPartial from './navigation-partial'

const mapStateToProps = (state: State) => ({
  toasts: state.toast.toasts,
})

const mapDispatchToProps = {
  hideToast: toastActions.hide,
}

interface OwnProps {
  children: React.ReactNode
  hideFooter?: boolean
  fixedHeight?: boolean
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type Props = ConnectedProps<typeof connector> & OwnProps

const PagePartial = ({
  children,
  toasts,
  hideToast,
  hideFooter = false,
  fixedHeight = false,
}: Props) => (
  <NavigationPartial>
    <PageLayout
      footer={!hideFooter ? <FooterPartial /> : undefined}
      fixedHeight={fixedHeight}
      toasts={
        <ToastLayout>
          {toasts.map(toast => (
            <Toast
              key={toast.id}
              type={toast.type}
              onClose={() => hideToast(toast.id)}
              timeout={toast.timeout}
              onTimeout={() => hideToast(toast.id)}
            >
              {toast.content}
            </Toast>
          ))}
        </ToastLayout>
      }
    >
      {children}
    </PageLayout>
  </NavigationPartial>
)

export default connector(PagePartial)
